import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { BonusSettlement } from '../models/bonus-settlement';
import {
    deleteBonusSettlement,
    fetchBonusSettlements,
    updateBonusSettlement,
} from './bonus-settlements-overview-actions';

export interface BonusSettlementsOverviewReducerState {
    bonusSettlements: PaginatedResponse<BonusSettlement>;
    requesting: boolean;
}

export const initialBonusSettlementsOverviewReducerState: BonusSettlementsOverviewReducerState = {
    bonusSettlements: { items: [], total: 0, limit: 10, page: 0 },
    requesting: false,
};

export const bonusSettlementsOverviewReducer = createReducer(initialBonusSettlementsOverviewReducerState, builder =>
    builder
        .addCase(fetchBonusSettlements.pending, state => {
            state.requesting = true;
        })
        .addCase(fetchBonusSettlements.fulfilled, (state, action) => {
            state.bonusSettlements = action.payload;
            state.requesting = false;
        })
        .addCase(fetchBonusSettlements.rejected, state => {
            state.requesting = false;
        })
        .addCase(updateBonusSettlement.fulfilled, (state, action) => {
            state.bonusSettlements.items = state.bonusSettlements.items = state.bonusSettlements.items.map(item =>
                item.id === action.payload.id ? { ...item, payout: action.payload.payout } : item
            );
        })
        .addCase(deleteBonusSettlement.fulfilled, (state, action) => {
            state.bonusSettlements.items = state.bonusSettlements.items.filter(item => item.id !== action.payload.id);
        })
);
